define('meetings/lib/past-meeting-report/past-meeting-report',['require','exports','module','moment','lodash','plugins/dialog','dialog-helper/responsive','web-urls','knockout','i18next','lib/auth/auth'],function (require, exports, module) {
    var moment = require('moment');
    var _ = require('lodash');
    var dialog = require('plugins/dialog');
    var responsiveDialog = require('dialog-helper/responsive');
    var meetingServicesURL = require('web-urls').get('meetingSvcUrl');
    var ko = require('knockout');
    var i18n = require('i18next');
    var auth = require('lib/auth/auth');

    function sanitizeAttendees(attendees) {
        var cleanAttendees = [];
        _.each(attendees, function (attendee) {
            var clean = {};
            clean.name = attendee.name ? attendee.name : '';
            clean.email = attendee.email ? attendee.email : '';
            if (attendee.joinTime && attendee.leaveTime) {
                var joinTime = moment(attendee.joinTime);
                var leaveTime = moment(attendee.leaveTime);
                if (i18n.t('web-technical.useAmPm') === 'false') {
                    clean.time = joinTime.format('HH:mm:ss') + ' - ' + leaveTime.format('HH:mm:ss');
                } else {
                    clean.time = joinTime.format('hh:mm:ss A') + ' - ' + leaveTime.format('hh:mm:ss A');
                }
            } else {
                clean.time = '';
            }
            cleanAttendees.push(clean);
        });
        return cleanAttendees;
    }

    function PastMeetingReport(title, attendees, sessionId) {
        var self = this;
        self.title = title;
        self.attendees = sanitizeAttendees(attendees);
        self.autoclose = true;

        self.close = function () {
            dialog.close(self);
        };

        self.token = ko.observable();

        self.excelUrl = ko.computed(function () {
            if (self.token()) {
                var tokenType = self.token().token_type;
                var accessToken = self.token().access_token;

                return meetingServicesURL + '/rest/2/reports/meetingAttendee?sessionId=' + sessionId +
                    '&_authorization=' + tokenType + ' ' + accessToken;
            }
            return null;
        });

        self.activate = function () {
            self.token(auth.getToken());
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
        };
    }
    module.exports = PastMeetingReport;
});

